"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../htmlSerializer/PrismicHtmlSerializer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable camelcase */
var SectionBody = function BodyComponent(_ref) {
  var sliceData = _ref.sliceData;
  var _sliceData$primary = sliceData.primary,
      section_body_text = _sliceData$primary.section_body_text,
      text_alignment = _sliceData$primary.text_alignment,
      list_item_style = _sliceData$primary.list_item_style;
  var bodyClasses = (0, _classnames["default"])({
    'content-page__section-body': true,
    'content-page__section-body--align-left': text_alignment === 'Left',
    'content-page__section-body--align-center': text_alignment === 'Center',
    'content-page__section-body--align-right': text_alignment === 'Right'
  });
  var listStyleMap = {
    Bullet: 'default',
    Checkmark: 'WithCheckmark'
  };
  var listStyle = listStyleMap[list_item_style] || listStyleMap.Bullet;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "se-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "content-page__section-body-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bodyClasses
  }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
    baseClass: "content-page__rich-text",
    content: section_body_text,
    options: {
      listItem: listStyle,
      hyperlink: 'WithExternalLinkIcon'
    }
  }))));
};

SectionBody.propTypes = {
  sliceData: _propTypes["default"].shape({
    primary: _propTypes["default"].shape({
      section_body_text: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
      text_alignment: _propTypes["default"].string.isRequired,
      list_item_style: _propTypes["default"].string.isRequired
    }).isRequired
  }).isRequired
};
var _default = SectionBody;
exports["default"] = _default;